import { Locales } from '../enum/locales';
import { IPromotionalApp } from '../interfaces/i-promotional-app';
import { TLocales } from '../type/locales';
import { OptimizedImage } from './optimized-image';

export class PromotionalApp {
  id: number;
  guid: string;
  app_id: string;
  title: string;
  url_schema: string;
  package_name: string;
  description: string;
  version_name: string;
  link_android: string;
  link_ios: string;
  version_code: number;
  priority: number;
  icon: OptimizedImage | null;
  screen: OptimizedImage | null;
  screen_ios: OptimizedImage | null;

  constructor(data: IPromotionalApp, locale: TLocales | string = Locales.en) {
    this.id = data.id;
    this.guid = data.guid;
    this.app_id = data.app_id;
    this.title = data.title;
    this.url_schema = data.url_schema;
    this.package_name = data.package_name;
    this.description = data.description;
    this.version_name = data.version_name;
    this.link_android = data.link_android;
    this.link_ios = data.link_ios;
    this.version_code = data.version_code;
    this.priority = data.priority;
    this.icon = data.icon ? new OptimizedImage(data.icon) : null;
    this.screen = data.screen ? new OptimizedImage(data.screen) : null;
    this.screen_ios = data.screen_ios
      ? new OptimizedImage(data.screen_ios)
      : null;
  }
}
